<script setup>

import AccountsRow from '../components/AccountsRow.vue';
import { onBeforeMount, onMounted } from "vue";
import setTooltip from "../assets/js/tooltip";
import router from "../router";
import cookie from '../assets/js/cookies.js';
import validSession from "../assets/js/valid-session.js";
import bootstrap from "bootstrap/dist/js/bootstrap";
import { useStore } from "vuex";
import axios from "axios";
import { toast } from 'vue3-toastify';
import loadGif from "@/assets/img/loading.gif"
import { computed } from "vue";
import { useI18n } from 'vue-i18n';

const value_balance = {
    value: 0
};

const { t } = useI18n();

const money = {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false /* doesn't work with directive */
        }

const getIcons = async () => {

    axios.get('bank-icons?type=account')
    .then(res => {
        
        if(res.status == 200){

            store.state.icons = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const store = useStore();

const darkMode = computed(() => store.state.darkMode);

onBeforeMount(() => {

    validSession.isLogged();

    store.state.validation = {
        nameHasError: false,
        nameMessageError: '',
    };

    store.state.account = {
        icon: 'https://assets.agive.com.br/financas/bancos/banco-logo.png',
        name: '',
        not_sum: false,
        id: '',
        balance: ''
    };

    store.state.icons = [];
    store.state.accounts = [];
    store.state.loadingAccounts = true;
    store.state.editBalance = false;

    store.state.toArchive = {
        icon: '',
        name: '',
    };

    getIcons();

    store.state.loadingAccounts = true;
    getAccounts();
  
})

onMounted(() => {
    setTooltip();

    let session = cookie.get('user_agive_session');

    if(session == null){
        router.push({name: 'Login'});
    }

});

const clearFields = () => {
    store.state.account = {
        icon: 'https://assets.dcsoftwares.com.br/imgs/bancos/banco-logo.png',
        name: '',
        not_sum: false,
        id: '',
        balance: 0
    };

    store.state.editBalance = false;

    store.state.toArchive = {
        icon: '',
        name: '',
    };
}

const getAccounts = async () => {

    axios.get('accounts')
    .then(res => {
        
        if(res.status == 200){

            store.state.accounts = res.data;
            store.state.loadingAccounts = false;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const submitAccount = async () => {

    let data = new FormData();

    store.state.validation.nameHasError = false;

    data.append('name', store.state.account.name);
    data.append('icon', store.state.account.icon);
    data.append('sum', store.state.account.not_sum == true ? 'No' : 'Yes');

    let url = '/accounts';
    let toast_message = t('message.accounts.account_created');

    if(store.state.account.id != ''){

        //console.log(value_balance);

        store.state.account.balance = value_balance.value.replace('R$ ', '');

        data.append('balance', store.state.account.balance);

        url = '/accounts/update/'+store.state.account.id;
        toast_message = t('message.accounts.account_updated');
    }

    await axios.post(url, data)
    .then(res => {

        if(res.data.error){

            let messages = res.data.messages;

            Object.entries(messages).forEach((value) => {

                if(value[0] == 'name'){
                    store.state.validation.nameHasError = true;
                    store.state.validation.nameMessageError = value[1];
                }

            })

        }
        else{

            store.state.validation = {
                nameHasError: false,
                nameMessageError: '',
            };

            closeModal('addAccount');

            clearFields();

            toast(toast_message, {
                autoClose: 1000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });

            getAccounts();

        }

    })
    .catch(err => {
        console.error(err); 
    })

}

const editAccount = (data) => {

    value_balance.value = formatMoney(data.balance);

    store.state.account = {
        icon: data.icon,
        name: data.name,
        not_sum:  data.sum == 'Yes' ? false : true,
        id: data.id,
        balance: data.balance
    };

}

const archiveAccount = async (account, archive) => {

    if(archive == 'Yes'){

        store.state.toArchive = {
            icon: account.icon,
            name: account.name,
        };

        openModal('confirmArchiveAccount');

        var confirmButton = document.getElementById('confirmArchiveAccountButton');
        confirmButton.addEventListener('click', async function () {
        // do something...
        
            let data = new FormData();

            data.append('archived', archive);

            let url = '/accounts/archive/'+account.id;
            let toast_message = t('message.accounts.account_archived');

            await axios.post(url, data)
            .then(res => {

                if(res.data.error){

                    console.log(res);

                }
                else{

                    toast(toast_message, {
                        autoClose: 1000,
                        theme: "auto",
                        type: "success",
                        transition: "slide"
                    });

                    closeModal('confirmArchiveAccount');
                    
                    getAccounts();

                }

            })
            .catch(err => {
                console.error(err); 
            })
            

        })

    }
    else{

        let data = new FormData();

        data.append('archived', archive);

        let url = '/accounts/archive/'+account.id;
        let toast_message = t('message.accounts.account_desarchived');

        await axios.post(url, data)
        .then(res => {

            if(res.data.error){

                console.log(res);

            }
            else{

                toast(toast_message, {
                    autoClose: 1000,
                    theme: "auto",
                    type: "success",
                    transition: "slide"
                });

                closeModal('confirmArchiveAccount');
                
                getAccounts();

            }

        })
        .catch(err => {
            console.error(err); 
        })

    }    

}

const deleteAccount = async (account) => {

    store.state.toArchive = {
        icon: account.icon,
        name: account.name,
    };

    openModal('deleteAccount');

    var confirmButton = document.getElementById('confirmExclusionAccountButton');
    confirmButton.addEventListener('click', async function () {
    // do something...

        let url = '/accounts/delete/'+account.id;
        let toast_message = t('message.accounts.account_deleted');

        await axios.post(url)
        .then(res => {

            if(res.data.error){

                console.log(res);

            }
            else{

                toast(toast_message, {
                    autoClose: 1000,
                    theme: "auto",
                    type: "success",
                    transition: "slide"
                });

                closeModal('deleteAccount');
                
                getAccounts();

            }

        })
        .catch(err => {
            console.error(err); 
        })
        

    })

}

const openModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.show();

}

const closeModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.hide();

}

function formatMoney(v) {
      let total = parseFloat(v);

      return total.toLocaleString(t('message.global.date_language'), {
        style: "currency",
        currency: "BRL",
      });
    }

</script>
<template>
    <div class="py-4 container-fluid overflow-auto max-height-vh-90">
        <div class="row">
            <div class="col-12">

                <div class="card">
                    <div class="card-header pb-0">
                        <div class="row align-items-center mb-n2 mb-md-2 mt-md-n2">
                            <div class="col-6">
                                <h6 class="text-white">{{ t('message.global.bank_account', 2) }}</h6>
                            </div>
                            <div class="col-6 text-end">
                                <a 
                                    class="me-3 trasation-list-add-button mt-n1 mb-2 text-white"
                                    type="button" 
                                    id="dropdownMenuButton1"
                                    @click="openModal('addAccount')"
                                    >
                                    <i class="fal fa-plus-circle"></i> <span class="d-none d-lg-inline-flex">{{ t('message.global.add') }}</span>
                                </a>
                                
                            </div>
                        </div>
                    </div>
                    <div class="card-body px-0 pt-0 pb-2">

                        <div class="col-12">

                            <div class="row">

                                <div class="col-12 text-center mt-4" v-if="store.state.loadingAccounts">
                                    <img :src="loadGif" alt="" width="60px">
                                </div>
                                <div class="col-12 text-center mt-4" v-if="store.state.accounts.length == 0 && !store.state.loadingAccounts">
                                    <p>{{ t('message.global.zero_accounts') }}</p>
                                </div>
                                <div class="col-12 mt-4 mb-4" v-if="!store.state.loadingAccounts">

                                    <AccountsRow
                                        v-for="(account, index) in store.state.accounts" :key="index"
                                        :bank="account.name"
                                        :id="account.id"
                                        :icon="account.icon"
                                        :edit="account"
                                        :darkmode="darkMode"
                                        @edit="editAccount"
                                        @archive="archiveAccount"
                                        @delete="deleteAccount"
                                    />

                                </div>

                            </div>

                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="addAccount" tabindex="-1" aria-labelledby="addAccount" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">

                        <div class="col-10">
                            <b>
                                {{ t('message.accounts.new_account') }}
                            </b>
                        </div>
                        <div class="col-2 text-end">
                            <a type="button" data-bs-dismiss="modal" @click="clearFields()">
                                <i class="fal fa-times-circle fa-lg"></i>
                            </a>
                        </div>

                        <div class="col-11 mx-auto">

                            <div class="row mt-4 mb-4">

                                <div class="col-3 account-create-icon-div">

                                    <img :src="store.state.account.icon" alt="" class="img-fluid rounded-5">

                                </div>
                                <div class="col-9">
                                    <div class="row">

                                        <div class="col-12 mb-3">
                                            <label for="accountName">{{ t('message.accounts.account_name') }}</label>
                                            <input 
                                                type="text" 
                                                class="form-control form-control-lg" 
                                                id="accountName"
                                                name="accountName"
                                                :placeholder="t('message.accounts.account_name')"
                                                v-model="store.state.account.name"
                                                v-bind:class="{
                                                    'is-invalid': store.state.validation.nameHasError,
                                                    'darkmode': darkMode,
                                                }"
                                            >
                                            <div id="categoryNameFeedback" class="invalid-feedback">
                                                {{ store.state.validation.nameMessageError }}
                                            </div>
                                        </div>

                                        <div v-if="store.state.account.id > 0 && !store.state.editBalance" class="col-12 mb-3">
                                            <h4>
                                                {{formatMoney(store.state.account.balance)}} 
                                                <span>
                                                    <i 
                                                        class="fal fa-pencil row-accounts-list-icons-actions cursor-pointer"
                                                        v-tooltip="{
                                                                    content:t('message.global.edit') + ' ' + t('message.global.balance'),
                                                                    distance: 15
                                                                }"
                                                                v-bind:class="{
                                                                    'text-black-50': !darkMode,
                                                                    'text-white-50': darkMode,
                                                                }"
                                                        @click="store.state.editBalance = true"
                                                        
                                                    >
                                                    </i>
                                                </span>
                                            </h4>
                                        </div>

                                        <div v-if="store.state.account.id > 0 && store.state.editBalance" class="col-12 mb-3">
                                            <label for="accountName">{{ t('message.global.balance') }}</label>
                                            <input 
                                                type="tel" 
                                                class="form-control form-control-lg" 
                                                id="accountName"
                                                name="accountName"
                                                :placeholder="t('message.accounts.account_balance')"
                                                v-model.lazy="value_balance.value" 
                                                v-money="money"
                                                v-bind:class="{
                                                    'darkmode': darkMode,
                                                }"
                                            >
                                            <p class="text-sm">
                                                {{ t('message.accounts.negative') }}
                                            </p>
                                        </div>

                                        <div class="col-12">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="store.state.account.not_sum">
                                                <label class="form-check-label" for="flexCheckDefault" 
                                                v-tooltip="{
                                                                content: t('message.accounts.not_sum_tooltip'), 
                                                                html: true,
                                                                distance: 15
                                                            }">
                                                    {{ t('message.accounts.not_sum') }}
                                                </label>
                                            </div>
                                        </div>    

                                    </div>
                                </div>                            

                            </div>

                            <div class="row mt-2 mb-2">
                                <hr>
                            </div>

                            <div class="row">

                                <div class="col-12">
                                    <p>{{ t('message.global.choose_icon') }}</p>
                                </div>

                                <div class="col-12 icon-list">

                                    <div class="row justify-content-center">

                                        <div
                                            v-for="(icon, index) in store.state.icons" :key="index"
                                            @click="store.state.account.icon = icon.path"
                                            class="icon-picker d-flex align-items-center text-dark" 
                                            :title="icon.name"
                                        >
                                            <img :src="icon.path" :alt="icon.name" class="rounded-5">
                                        </div>

                                    </div>

                                </div>
                                
                            </div>

                            <div class="row mt-2 mb-2">
                                <hr>
                            </div>

                            <div class="row">
                                
                            </div>

                            <div class="row mt-3">
                                <div class="col-12 text-center">
                                    <button
                                        @click="submitAccount()"
                                        class="btn btn-success"
                                    >
                                    {{ store.state.account.id == '' ? t('message.accounts.add_account') : t('message.accounts.update_account') }}
                                    </button>
                                </div>
                            </div>

                        </div>

                        

                        

                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="modal fade" id="confirmArchiveAccount" tabindex="-1" aria-labelledby="confirmArchiveAccount" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">

                        <div class="col-11 mx-auto mt-4 mb-4">
                            <h5 class="mb-4">{{ t('message.accounts.archive_title') }}</h5>

                            <div class="col-12 text-center mt-3 mb-3">
                                <img :src="store.state.toArchive.icon" alt="" width="100" class="rounded">
                                <br>
                                <h4>{{store.state.toArchive.name}}</h4>
                            </div>

                            <div class="col-12 col-lg-10 mx-auto text-start mt-3 mb-3" v-html="t('message.accounts.archive_disclaim')">
                                
                            </div>

                        </div>
                        <div class="col-12 text-center">
                            <button
                                id="confirmArchiveAccountButton" 
                                class="btn btn-success"
                            >
                                {{ t('message.accounts.archive_button') }}
                            </button>

                            <a @click="closeModal('confirmArchiveAccount')" class="btn btn-link">{{ t('message.global.cancel') }}</a>
                        </div>

                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="modal fade" id="deleteAccount" tabindex="-1" aria-labelledby="deleteCategoryModal" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="col-11 mx-auto mt-4 mb-4">
                        <h5 class="mb-4">{{ t('message.accounts.delete_title') }}</h5>

                        <div class="col-12 text-center mt-3 mb-3">
                            <img :src="store.state.toArchive.icon" alt="" width="60" class="rounded">
                            <br>
                            <h4>{{store.state.toArchive.name}}</h4>
                        </div>

                        <div class="col-12 col-lg-10 mx-auto text-start mt-3 mb-3" v-html="t('message.accounts.delete_disclaim')">
                            
                        </div>

                    </div>
                    <div class="col-12 text-center">
                        <button
                            id="confirmExclusionAccountButton" 
                            class="btn btn-danger"
                        >
                            {{ t('message.accounts.delete_button') }}
                        </button>

                        <a @click="closeModal('deleteAccount')" class="btn btn-link">{{ t('message.global.cancel') }}</a>
                    </div>
                </div>
                
            </div>
        </div>
    </div>

</template>

<style>

    .account-create-icon-div{
        height: 50px;
    }

    .account-create-icon{
        min-height: 100%;
    }

    .icon-picker{
        margin: 2px 4px 2px 0;
        width: 60px !important;
        height: 60px !important;
        cursor: pointer;
    }

    .icon-picker img {
        width: 100%;
        border-radius: 0.25rem
    }

    .icon-create{
        font-size: 30px;
    }

    .icon-list{
        height: 150px;
        overflow-x:auto;
    }

    .cursor-pointer{
        cursor: pointer;
    }

    @media (max-width: 575.98px) {

        .category-create-icon-div{
            height: 60px;
        }
    }
</style>